"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
// See also manatee/src/components/icons/Alerts/
const Info = ({ size, fill = "#84e3ff", ...rest }) => {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size ? size : 16, height: size ? size : 16, fill: fill, viewBox: "0 0 16 16", ...rest },
        react_1.default.createElement("path", { d: "M8,1a7,7,0,1,0,7,7A7,7,0,0,0,8,1ZM9,8v3l1,2H7V8L6,6H9ZM9,5H7V3H9Z" })));
};
exports.default = Info;
//# sourceMappingURL=index.js.map